import React from 'react'
import Home from './pages/Home'
import About from './pages/About'
import Error from './pages/Error'
import Pricing from './pages/Pricing'
import Signin from './pages/Signin'
import Signup from './pages/Signup'
import Waitlist from './pages/Waitlist'

import { BrowserRouter, Routes, Route } from 'react-router-dom'



function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/waitlist' element={<Waitlist />} />
        <Route path='/' element={<Home />} />
        <Route path='/signup' element={<Signup />} />
        <Route path='/error' element={<Error />} />
        <Route path='/about' element={<About />} />
        <Route path='/signin' element={<Signin />} />
        <Route path='/pricing' element={<Pricing />} />
        <Route path='/scrollTop' element={<scrollTop />} />
      </Routes>
    </BrowserRouter>

  )
}

export default App